import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const statusPill = (s) => {
  const map = {
    submitted: "bg-amber-soft/40 text-ink",
    restaurant_accepted: "bg-amber/20 text-ink",
    deposit_paid: "bg-ink text-cream",
    confirmed: "bg-ink text-cream",
    completed: "bg-green-100 text-green-900",
    cancelled: "bg-tablo-border text-light-ink",
    rejected: "bg-rose-100 text-rose-900",
    no_show: "bg-rose-200 text-rose-900",
    draft: "bg-cream border border-tablo-border text-light-ink",
  };
  return map[s] || "bg-cream border border-tablo-border text-light-ink";
};

export default function MyBookings() {
  const [list, setList] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/bookings");
        setList(data);
      } catch (e) {
        // ignore
      }
    })();
  }, []);

  const today = new Date().toISOString().slice(0, 10);
  const upcoming = list.filter((b) => b.date >= today && !["cancelled", "rejected"].includes(b.status));
  const past = list.filter((b) => b.date < today || ["completed", "cancelled", "rejected"].includes(b.status));

  const Card = ({ b }) => (
    <Link to={`/confirmation/${b.id}`} className="tablo-card p-5 block hover:shadow-tablo-lg transition-shadow" data-testid={`booking-row-${b.id}`}>
      <div className="flex items-start justify-between">
        <div>
          <p className="font-serif text-xl">{b.restaurant?.name}</p>
          <p className="text-xs text-light-ink mt-1">{b.date} · {b.time} · {b.pax} guests</p>
        </div>
        <span className={`tablo-pill ${statusPill(b.status)}`}>{b.status.replace("_", " ")}</span>
      </div>
      {b.package && <p className="text-sm text-light-ink mt-2">{b.package.name} · ₹{b.package.price_per_head_inr}/head</p>}
    </Link>
  );

  return (
    <div className="space-y-5 animate-fade-up">
      <header>
        <p className="text-amber text-xs uppercase tracking-[0.18em] font-medium mb-2">My bookings</p>
        <h1 className="font-serif text-3xl">Your Tablo plans, all in one place.</h1>
      </header>

      <Tabs defaultValue="upcoming">
        <TabsList className="bg-cream border border-tablo-border">
          <TabsTrigger value="upcoming" data-testid="tab-upcoming">Upcoming ({upcoming.length})</TabsTrigger>
          <TabsTrigger value="past" data-testid="tab-past">Past ({past.length})</TabsTrigger>
        </TabsList>
        <TabsContent value="upcoming" className="space-y-3 mt-4">
          {upcoming.length === 0 ? (
            <div className="tablo-card p-8 text-center text-light-ink">
              <p>No upcoming bookings yet.</p>
              <Link to="/home" className="text-amber underline text-sm mt-2 inline-block" data-testid="empty-plan-link">Plan one →</Link>
            </div>
          ) : upcoming.map((b) => <Card key={b.id} b={b} />)}
        </TabsContent>
        <TabsContent value="past" className="space-y-3 mt-4">
          {past.length === 0 ? (
            <div className="tablo-card p-8 text-center text-light-ink">No past bookings.</div>
          ) : past.map((b) => <Card key={b.id} b={b} />)}
        </TabsContent>
      </Tabs>
    </div>
  );
}
